import axios from 'axios'

// state
export const state = {
  accessories: []
}

// getters
export const getters = {
  accessories: state => {
    return state.accessories
  },

  getAccessoryById: state => (id) => {
    return state.accessories.find(accessory => accessory.id === id)
  },

  /**
   * Get all Utils accessories
   *
   * @param state
   * @returns {*}
   */
  getAccessoriesUtils: state => {
    return state.accessories.filter(accessory => accessory.type === 'utils')
  }
}

// mutations
export const mutations = {
  FETCH_ACCESSORIES (state, { accessories }) {
    state.accessories = accessories
  },

  SET_ACCESSORY (state, accessory) {
    state.accessories.push(accessory)
  },

  UPDATE_ACCESSORY (state, accessory) {
    var foundIndex = state.accessories.findIndex(x => x.id === parseInt(accessory.id))
    state.accessories[foundIndex] = accessory
  },

  DELETE_ACCESSORY (state, id) {
    var foundIndex = state.accessories.findIndex(x => x.id === parseInt(id))
    state.accessories.splice(foundIndex, 1)
  }
}

// actions
export const actions = {
  async fetchAccessories ({ commit }) {
    try {
      const { data } = await axios.get('/api/accessory')
      commit('FETCH_ACCESSORIES', { accessories: data })
    } catch (e) {
    }
  },

  async setAccessory ({ commit }, accessory) {
    try {
      commit('SET_ACCESSORY', accessory)
    } catch (e) {
    }
  },
  async updateAccessory ({ commit }, accessory) {
    try {
      commit('UPDATE_ACCESSORY', accessory)
    } catch (e) {
    }
  },
  async deleteAccessory ({ commit }, id) {
    try {
      commit('DELETE_ACCESSORY', id)
    } catch (e) {
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/accessories.js